import request from "./request";

export default {
  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },

  setStatusLogin({ commit }, data) {
    commit("SET_LOGGED_STATUS", data);
  },
  getUserGeo({ commit }) {
    request.getUserGeo().then((data) => {
      let user_geo_data = {
        ip: data.ip,
        town: data.city,
        country: data.country_name,
      };
      commit("SET_URSER_GEO", user_geo_data);
    });
  },

  sendComent({ commit }, data) {
    return new Promise((resolve, reject) => {
      request
        .sendComment(data)
        .then((data) => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
